import BaseMixin from "./BaseMixin"

export default {
  mixins: [BaseMixin],
  data() {
    return {
      pageRequest: {
        page: 0,
        size: 10
      }
    }
  },
  methods: {
      crudListar(options){
        this._validate()
        return this.$axios.$post(`${this.pathApi}`, this.pageRequest, options)
      }
  }
}
